import { ULD_CORE_STATUS_OPTIONS, validateStatusTransition } from "../UldManagement/constants/uldConstantsV3";

export function getCommonTargetStatusOptions(selectedUlds = []) {
    if (!selectedUlds.length) {
        return [];
    }

    return ULD_CORE_STATUS_OPTIONS.filter((option) =>
        selectedUlds.every((uld) => {
            const fromStatus = uld.stock?.core_status || "IN_STOCK";
            return validateStatusTransition(fromStatus, option.value);
        }),
    );
}
